var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM13,5c-1.6-2.7-5.1-3.7-7.9-2.1","key":0}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t14.8,8.6 11.2,5.9 13,5 14.8,4.1 \t","key":1}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3,11c1.6,2.7,5.1,3.7,7.9,2.1","key":2}),React.createElement("polygon",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t1.2,7.4 4.8,10.1 3.1,11 1.2,11.9 \t","key":3})]));
}

Refresh.displayName = "Refresh";

Refresh.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Refresh;

Refresh.default = Refresh;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/refresh.svg
// module id = ../icon/src/icons/refresh.svg
// module chunks = 0